/**
 * Check if the user can trigger an email
 * @param {Array} roles - The roles of the user
 * @returns {Boolean}
 */
export const userCanTriggerEmail = (roles) => {
  const rolesThatCanTriggerEmail = ['perform', 'revenue', 'admin'];
  return roles && roles.some((role) => rolesThatCanTriggerEmail.includes(role));
};

export const isLongTailAssessment = (customerChannel) => {
  return customerChannel && customerChannel.startsWith('LT');
};
